<template>
  <el-dialog v-bind="$attrs" v-on="$listeners" title="醒目" width="500px" @open="onOpen">
    <div class="mark-item">
      <el-radio v-model="marked" :label="1">醒目标识</el-radio>
      <el-date-picker size="small" v-model="markedEndTime" type="datetime" placeholder="设置到期时间"> </el-date-picker>
    </div>
    <div class="mark-item">
      <el-radio v-model="marked" :label="0">取消醒目标识</el-radio>
    </div>

    <div class="mark-footer" slot="footer">
      <el-button size="medium" @click="$emit('update:visible', false)">取消</el-button>
      <el-button size="medium" type="primary" :loading="markLoading" @click="onMark">确定</el-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: 'DialogMark',
  props: { post: { type: Object, required: true } },
  data() {
    return {
      marked: 0,
      markedEndTime: undefined,

      markLoading: false,
    };
  },
  methods: {
    onOpen() {
      this.marked = this.post.property.marked || 0;
    },
    /**
     * 醒目
     */
    async onMark() {
      if (this.marked === 1 && !this.markedEndTime) {
        return this.$warning('请选择醒目标识到期时间');
      }

      this.markLoading = true;
      let sendData = {
        postId: [this.$route.params.id],
        marked: this.marked,
      }
      if( this.marked == 1){
        sendData['markedEndTime'] = new Date(this.markedEndTime).toISOString();
      }
      await this.$axios
        .post('/car/v1/advertising/post', sendData)
        .finally(() => {
          this.markLoading = false;
        });

      this.$success('操作成功');
      window.location.reload();
    },
  },
};
</script>
<style lang="scss" scoped>
.mark-item {
  padding-left: 30px;
  &:not(:last-child) {
    margin-bottom: 20px;
  }
}
</style>
